import images from "./images";

const menu = {
    hotCoffee: [
        {
            id: 1,
            name: "Guatemalan",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A medium roast with initial notes of milk chocolate that transition into a sweet orange mild citrus finish.",
            image: images.espresso1,
        },
        {
            id: 2,
            name: "Colombian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A silky smooth body with notes of almond and chocolate, finishing with a bright hint of citrus.",
            image: images.espresso2,
        },
        {
            id: 3,
            name: "Costa Rican Tarrazu",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A medium roast with bright acidity, sweet honey, and chocolate for a full-flavored cup.",
            image: images.espresso3,
        },
        {
            id: 4,
            name: "Samutran",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Low acidity with a smooth chocolate flavor complemented by earthy undertones.",
            image: images.espresso4,
        },
        {
            id: 5,
            name: "Mexican",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Mild yet flavorful, with sweet brown sugar and pear notes plus a clean nutty finish.",
            image: images.espresso5,
        },
        {
            id: 6,
            name: "Tanzanian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Wonderfully smooth and full-bodied, rich without overpowering, with a clean crisp taste.",
            image: images.espresso6,
        },
        {
            id: 7,
            name: "Ethiopian Yirgacheffe",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Bright citrus notes like sweet tangerine and lime, powerful acidity, and a dry lemon tea finish.",
            image: images.espresso7,
        },
        {
            id: 8,
            name: "Kenyan",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Bright, complex, and exceptionally sweet with low acidity and a lovely floral fragrance.",
            image: images.espresso8,
        },
        {
            id: 9,
            name: "Perubian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Rich depth with medium acidity, spiced cinnamon up front, caramel sweetness, and a lingering citrus finish.",
            image: images.espresso1,
        },
        {
            id: 10,
            name: "Papua New Guinea",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Smooth and sweet with medium body, creamy feel, candied walnut, chocolate, spices, and a dark fruity finish.",
            image: images.espresso2,
        },
        {
            id: 11,
            name: "Haitian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Rare organic coffee with spicy cinnamon notes, sweet herbaceousness, and a rich plum finish.",
            image: images.espresso3,
        },
        {
            id: 12,
            name: "Honduras",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Nutty and bright with milk chocolate notes, a smooth sugary-sweet body, and a lemon wedge finish.",
            image: images.espresso4,
        },
        {
            id: 13,
            name: "Brazillian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Medium-dark roasted coffee with dry cocoa throughout the cup and a savory walnut finish.",
            image: images.espresso5,
        },
        {
            id: 14,
            name: "Dominican Republic",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Sweet, well-rounded, and low in acidity with notes of sweet apple, grape, and vanilla.",
            image: images.espresso6,
        },
        {
            id: 15,
            name: "Uganda",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Bold and intense from a longer roast, strong and smooth with mild acidity and sweet dark chocolate notes.",
            image: images.espresso7,
        },
        {
            id: 16,
            name: "Indian",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Monsoon Malabar with unmatched smoothness, mellow flavor, baker's chocolate, and a mild creamy finish.",
            image: images.espresso8,
        },
        {
            id: 17,
            name: "Vietnamese",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Bold, intense dark roast that is strong, slightly sweet, earthy, and often roasted with butter.",
            image: images.espresso1,
        },
        {
            id: 18,
            name: "Cuban Espresso",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. High caffeine coffee ideal for an energizing brew without bitterness, with dark chocolate and black cherry notes.",
            image: images.espresso2,
        },
        {
            id: 19,
            name: "Italian Espresso",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Dark roast with red fruit notes and a dense bittersweet body; rich, tangy, and pleasing for dark roast lovers.",
            image: images.espresso3,
        },
        {
            id: 20,
            name: "Black Knight",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A dangerously dark roast with tropical plantain notes and intense caramelized sugar.",
            image: images.espresso4,
        },
        {
            id: 21,
            name: "Classic Medium Roast",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A premium artisan blend that is bold but balanced, a little sweet, with a super clean finish.",
            image: images.espresso5,
        },
        {
            id: 22,
            name: "Breakfast Blend",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. A light artisan roast crafted to be flavorful, rich, and wonderfully balanced on the palate.",
            image: images.espresso6,
        },
        {
            id: 23,
            name: "Jamaican Me Crazy",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Flavored coffee with sweet caramel, vanilla bean, and coffee liqueur flavors blended together.",
            image: images.espresso7,
        },
        {
            id: 24,
            name: "Hawaiian Macadamia Nut",
            price: "3.95 / $4.95",
            description: "12oz / 16oz. Sweet, buttery, and nutty with a special smooth island-inspired flavor.",
            image: images.espresso8,
        }
    ],
    coldCoffee: [
        {
            id: 1,
            name: "Bottle Water",
            price: 1.50,
            description: "Chilled bottled water.",
            image: images.bottledWater,
        },
        {
            id: 2,
            name: "Iced Coffee",
            price: 4.95,
            description: "16oz iced coffee, served chilled and customizable with coffee syrups.",
            image: images.coldBrew2,
        },
        {
            id: 3,
            name: "Ice Tea",
            price: 2.25,
            description: "16oz refreshing iced tea.",
            image: images.coldBrew3,
        },
        {
            id: 4,
            name: "Smoothie",
            price: 6.50,
            description: "16oz smoothie available in Strawberry, Banana, Mango, Peach, and Pina Colada.",
            image: images.coldBrew4,
        },
        {
            id: 5,
            name: "Whey Protein Add-In",
            price: 2.00,
            description: "Add whey protein to any smoothie.",
            image: images.coldBrew5,
        },
        {
            id: 6,
            name: "Coffee Syrups",
            price: 0.50,
            description: "Extra pump options include Vanilla, Hazelnut, Caramel, Raspberry, Lavender, Peppermint, Strawberry, Cinnamon, and more.",
            image: images.coffeeSyrups,
        }
    ],
    sweets: [
        {
            id: 1,
            name: "Fresh Baked Pastries",
            price: "2.00 - $5.00",
            description: "Fresh baked pastry selections available daily. Pair with hot coffee, iced coffee, tea, or smoothies.",
            image: images.sweet1,
        }
    ]

};

export default menu;
